import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { authApi } from "./authApi";
import { oAuthApi } from "./oAuthApi";

const initialState = {
  user: null,
  accessToken: null as string | null,
  xAuth: null as string | null,
  isAuthenticated: false,
  email: "",
  displayName: "",
};

const authSlice = createSlice({
  name: "auth",
  initialState: {
    ...initialState,
    accessToken: localStorage.getItem("accessToken"),
    xAuth: localStorage.getItem("X-Auth"),
    isAuthenticated: !!localStorage.getItem("accessToken"),
    email: localStorage.getItem("email") || "",
    displayName: localStorage.getItem("displayName") || "",
  },
  reducers: {
    logout: () => {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("X-Auth");
      localStorage.removeItem("email");
      localStorage.removeItem("displayName");
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(authApi.endpoints.login.matchFulfilled, (state, action) => {
      state.accessToken = action.payload.data.accessToken;
      state.isAuthenticated = true;
      state.email = action.payload.data.email;
      state.displayName = action.payload.data.displayName;
      localStorage.setItem("accessToken", state.accessToken);
      localStorage.setItem("email", state.email);
      localStorage.setItem("displayName", state.displayName);
    });
    builder.addMatcher(authApi.endpoints.login.matchRejected, (state) => {
      state.isAuthenticated = false;
      state.accessToken = null;
      state.email = "";
      state.displayName = "";
      localStorage.removeItem("email");
      localStorage.removeItem("displayName");
    });
    builder.addMatcher(authApi.endpoints.login.matchPending, (state) => {
      state.isAuthenticated = false;
      state.accessToken = null;
      state.email = "";
      state.displayName = "";
      localStorage.removeItem("email");
      localStorage.removeItem("displayName");
    });
    builder.addMatcher(oAuthApi.endpoints.submitGoogleResponse.matchFulfilled, (state, action) => {
      state.accessToken = action.payload.data.accessToken;
      state.isAuthenticated = true;
      state.email = action.payload.data.email;
      state.displayName = action.payload.data.displayName;
      const xAuth: string = (action.meta.baseQueryMeta as any).response.headers.get("X-Auth");
      state.xAuth = xAuth;
      localStorage.setItem("accessToken", state.accessToken);
      localStorage.setItem("X-Auth", xAuth);
      localStorage.setItem("email", state.email);
      localStorage.setItem("displayName", state.displayName);
    });
    builder.addMatcher(oAuthApi.endpoints.submitGoogleResponse.matchRejected, (state) => {
      state.isAuthenticated = false;
      state.accessToken = null;
      state.xAuth = null;
      state.email = "";
      state.displayName = "";
      localStorage.removeItem("email");
      localStorage.removeItem("displayName");
    });
    builder.addMatcher(oAuthApi.endpoints.submitGoogleResponse.matchPending, (state) => {
      state.isAuthenticated = false;
      state.accessToken = null;
      state.xAuth = null;
      state.email = "";
      state.displayName = "";
      localStorage.removeItem("email");
      localStorage.removeItem("displayName");
    });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;

export const selectUser = (state: RootState) => state.auth.user;
export const selectToken = (state: RootState) => state.auth.accessToken;
export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated;
export const selectEmail = (state: RootState) => state.auth.email;
export const selectDisplayName = (state: RootState) => state.auth.displayName;
